import React, { FC, useCallback } from "react";
import { Container, Typography } from "@material-ui/core";
import makeStyles from "@material-ui/core/styles/makeStyles";
import { RouteComponentProps } from "react-router";
import { Helmet } from "react-helmet";
import { endOfTitle } from "../../../../constants/constants";
import { Form } from "react-final-form";
import Paper from "@material-ui/core/Paper";
import { makeCustomPaymentValidator } from "../../validators/makeCustomPaymentValidator";
import MakeCustomPaymentForm from "../../components/MakeCustomPaymentForm";
import { NotifyMode } from "../../../notify/NotifyModeEnum";
import { mutateErrors } from "../../../../utils";
import { useRecaptcha } from "../../../../hooks/useRecaptcha";
import usePaymentQueries from "../../hooks/usePaymentQueries";
import { useNotify } from "../../../notify/useNotify";
import { ICustomPayment } from "../../types";

const useStyles = makeStyles(() => ({
  container: {
    width: 800,
  },
  footer: {
    marginTop: 16,
  },
}));

const MakeCustomPaymentPage: FC<RouteComponentProps> = () => {
  const classes = useStyles();

  const { executeRecaptcha } = useRecaptcha();
  const { createCustomCheckoutSession } = usePaymentQueries();
  const snackNotify = useNotify();

  const handleSubmit = useCallback(
    async (data) => {
      try {
        const recaptchaToken = await executeRecaptcha(
          "create_custom_checkout_session",
        );

        const customPayment: ICustomPayment = {
          amount: +data.amount,
          comment: data.comment,
        };

        const {
          data: { redirectUrl },
        } = await createCustomCheckoutSession(customPayment, recaptchaToken);
        // redirecting to payment checkout page
        window.location.replace(redirectUrl);
      } catch (e) {
        const { message } = mutateErrors(e);
        snackNotify("Error", message, NotifyMode.ERROR);
      }
    },
    [createCustomCheckoutSession, executeRecaptcha],
  );

  return (
    <Container maxWidth={"md"} className={classes.container}>
      <Helmet>
        <title>Make Custom Payment{endOfTitle}</title>
      </Helmet>
      <Paper>
        <Form
          onSubmit={handleSubmit}
          component={MakeCustomPaymentForm}
          validate={makeCustomPaymentValidator}
        />
        <Typography component="p" align="center" className={classes.footer}>
          This site is protected by reCAPTCHA and the Google{" "}
          <a href="https://policies.google.com/privacy">Privacy Policy</a> and{" "}
          <a href="https://policies.google.com/terms">Terms of Service</a>{" "}
          apply.
        </Typography>
      </Paper>
    </Container>
  );
};

export default MakeCustomPaymentPage;
